export default "__VITE_ASSET__MzWr$0sz__"